<template>
  <div class="sys-tissues">
    <ToolBar :searchArr="fields"
             :showAdd="showAdd"
             :showChildren="showChildren"
             :showChildrenText="showChildrenText"
             @filter="filterFields"
             @search="search"
             @add="add"
             @expand="expand"
             placeholder="输入菜单名称搜索"></ToolBar>
    <div class="table-content">
      <Table ref="table"
             :isPagination="isPagination"
             :expandedRowKeys.sync="expandedRowKeys"
             :options="fields"
             :tableValue="tableValue"
             :customSlotOpt="slotOpt"
             :otherOpt="customOtherOpt"
             @change="initTableValue"
             @actionClick="handlerActionClick"
             :scroll="{ x: 1300, y: `calc(100vh - ${234 + 'px'})` }"></Table>
      <AModal ref="modal"
              :customOpt="customModalOpt"
              @ok="handlerOk"></AModal>
      <Modal :row="row"
             :treeData="tableValue"
             :isEdit="isEdit"
             :visible="visible"
             @ok="handleClickOk"></Modal>
    </div>
  </div>
</template>

<script>
import { getMenuList } from '@/api/back.js'
import { fields, slotOpt } from './config'
import mixinsBackStack from '@/views/Back/mixins'
import ToolBar from '../../components/toolBar/index.vue'
import Table from '@/views/Back/components/table/index.vue'
import AModal from '@/views/Back/components/AModal'
import Modal from './modal.vue'
export default {
  mixins: [mixinsBackStack],
  components: {
    ToolBar,
    Table,
    AModal,
    Modal
  },
  data() {
    return {
      row: {},
      isEdit: false,
      visible: false,
      showAdd: false,
      showExp: false,
      isPagination: false,
      fields,
      slotOpt,
      expandedRow: [],
      expandedRowKeys: [],
      showChildren: true,
      showChildrenText: true,
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      tableValue: []
    }
  },
  watch: {
    expandedRowKeys: {
      handler() {
        if (this.expandedRowKeys.length === this.expandedRow.length) {
          this.showChildrenText = false
        } else {
          this.showChildrenText = true
        }
      }
    }
  },
  mounted() {
    this.initTableValue()
  },
  methods: {
    handleClickOk() {
      this.visible = false
      this.row = null
      this.isEdit = false
      this.initTableValue()
    },
    async initTableValue(query = {}) {
      try {
        this.loadingTable(true) // 开启表格的加载动画
        //const params = this.handlerBeforeRequestParams()
        const { data } = await getMenuList(query) // 请求表格数据接口
        // const row = this.handlerDateFormat(rows) // 处理时间格式
        // this.handlerResultMappings(rows) // 处理数据的映射关系
        this.recursion(data)
        this.tableValue = data
        //this.customOtherOpt.pagination.total = total
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
      } finally {
        this.loadingTable(false)
      }
    },
    recursion(list) {
      list.forEach((item) => {
        // 处理时间格式，覆盖原始接口返回的参数
        item.key = item.id
        item.value = item.id
        item.title = item.label
        if (item.status === '0') {
          item.statusStr = '开放'
        } else {
          item.statusStr = '隐藏'
        }
        if (item.children && item.children.length) {
          this.expandedRow.push(item.id)
          this.recursion(item.children)
        }
      })
      return list
    },
    //点击折叠或者展开
    expand() {
      if (this.expandedRowKeys.length === this.expandedRow.length) {
        this.expandedRowKeys = []
        this.showChildrenText = true
      } else {
        this.expandedRowKeys = [...this.expandedRow]
        this.showChildrenText = false
      }
    },
    // 请求前的参数收集
    handlerBeforeRequestParams(searchParam) {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        ...searchParam,
        pageNum,
        pageSize
      }
      return params
    },
    search(v) {
      v ? this.initTableValue({ menuName: v }) : this.initTableValue()
    },
    add(row) {
      this.row = row
      this.visible = true
    },
    configMenu(row) {
      this.isEdit = true
      this.visible = true
      this.row = row
      console.log(this.row, 'this.row')
    },
    // 单独删除
    singleDelete(row) {
      this.customModalOpt.contentTips = '是否确定删除该内容'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      console.log(ids)
      try {
        //const { msg, code } = await deleteEnterPrise(ids)
        //this.initTableValue()
        //this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    normal() {},
    banned() {},
    filterFields({ v, i }) {
      this.$set(this.fields[i], 'isShow', v)
    }
  }
}
</script>

<style>
</style>